

import { createSlice } from '@reduxjs/toolkit';

export const rectifier_alarm_Slice = createSlice({
    name: 'rectifier_ALARM_alarm',
    initialState: {
        loading: false,
        active_loading: false,
        data: {

        },
         active_data: {

        },
        alarms: [],
        alarm_count: {},
        alarm_nav: {},
        alarm_master_data: {},
        active_alarms: [],
        error: false,
    },
    reducers: {
        RECTIFIER_ALARM_FETCH_START: (state) => {
            state.loading = true
        },
        RECTIFIER_ACTIVE_ALARM_FETCH_START: (state) => {
            state.active_loading = true
        },
        RECTIFIER_ALARM_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.alarms = action.payload.alarms
        },
        RECTIFIER_ALARM_FETCH_LOAD_MORE: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.alarms = [...state.alarms, ...action.payload.alarms]
        },
         RECTIFIER_ALARM_COUNT_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.alarm_count = action.payload
        },
         RECTIFIER_ALARM_NAV_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.alarm_nav = action.payload
        },
         RECTIFIER_ALARM_MASTER_FETCH_SUCCESS: (state, action) => {
            state.alarm_master_data = action.payload
            
        },
        RECTIFIER_ACTIVE_ALARM_FETCH_SUCCESS: (state, action) => {
            state.active_loading = false
            state.active_data = action.payload
            state.active_alarms = action.payload.alarms
        },
        RECTIFIER_ACTIVE_ALARM_FETCH_LOAD_MORE: (state, action) => {
             state.active_loading = false
             state.active_data = action.payload
            state.active_alarms = [...state.active_alarms, ...action.payload.alarms]
        },
       
        RECTIFIER_ALARM_FETCH_ERROR: (state) => {
            state.error = true
        }
    }
});

export const {RECTIFIER_ACTIVE_ALARM_FETCH_START,RECTIFIER_ACTIVE_ALARM_FETCH_SUCCESS,RECTIFIER_ACTIVE_ALARM_FETCH_LOAD_MORE,RECTIFIER_ALARM_MASTER_FETCH_SUCCESS,RECTIFIER_ALARM_COUNT_FETCH_SUCCESS,RECTIFIER_ALARM_NAV_FETCH_SUCCESS, RECTIFIER_ALARM_FETCH_LOAD_MORE, RECTIFIER_ALARM_FETCH_START, RECTIFIER_ALARM_FETCH_SUCCESS, RECTIFIER_ALARM_FETCH_ERROR } = rectifier_alarm_Slice.actions;
export default rectifier_alarm_Slice.reducer;